import fetch from 'lib/fetch'
import { useMutation, useQuery } from '@tanstack/react-query'

export const api = {}
export const PRODUCTS_STALE_TIME = 600000

api.coregistration = {
  route: '/api/v3/coregistration/registration',
  path: function path() {
    return this.route
  },
  register: function postRegistration(payload = null) {
    return fetch(this.path(), {
      method: 'POST',
      body: JSON.stringify(payload),
    })
  },
  useRegister: function useRegister(options) {
    return useMutation({ mutationFn: this.register.bind(this), ...options })
  },
}

api.productRecommendations = {
  route: '/api/v3/products/:id/recommendations',
  path: function path(productId) {
    return this.route.replace(':id', productId)
  },
  fetchProductRecommendations: function getProductRecommendations(productId) {
    return fetch(this.path(productId))
  },
  useProductRecommendationsQueryKey: function useProductRecommendationsQueryKey(
    productKey
  ) {
    const [gpId, productId] = productKey
    return ['product-recommendations', gpId, productId]
  },
  useProductRecommendations: function useProductRecommendations(
    productsKey,
    options = {
      refetchOnWindowFocus: false,
    }
  ) {
    const [key, gpId, productId] = this.useProductRecommendationsQueryKey.call(
      this,
      productsKey
    )

    return useQuery({
      queryKey: [key, gpId, productId],
      queryFn: () => this.fetchProductRecommendations(productId),
      ...options,
    })
  },
}

api.products = {
  route: '/api/v3/products/:id',
  path: function path(productId) {
    return this.route.replace(':id', productId)
  },
  fetchProduct: function getProduct(productId) {
    return fetch(this.path(productId))
  },
  useProductQueryKey: function useProductQueryKey(productKey) {
    const [gpId, productId] = productKey
    return ['product', gpId, productId]
  },
  useProduct: function useProduct(productKey, options = {}) {
    const [key, gpId, productId] = this.useProductQueryKey.call(
      this,
      productKey
    )

    return useQuery({
      queryKey: [key, gpId, productId],
      queryFn: () => this.fetchProduct(productId),
      ...options,
    })
  },
  utils: {
    /**
     *
     * @param {QueryClient} queryClient react-query client instance you want primed
     * @param {object} data data from the useProduct call (usually from onSuccess config callback)
     * @param {array} productKey productKey, [gpId, productId], from useProduct call, but mainly to read the generic product
     *                           to generate a new productQueryKey for the to be primed cache.
     */
    primeUseProductCache: function primeUseProductCache(
      queryClient,
      data,
      productKey
    ) {
      const [gpIdKey, productIdKey] = productKey
      const allProducts = Object.keys(data.genericProduct.products ?? {})
        .map((productIdKey) => parseInt(productIdKey))
        .filter((productId) => productId !== productIdKey ?? null)
        .map((productId) => data.genericProduct.products[productId])

      allProducts.forEach((product) => {
        const targetQueryKey = api.products.useProductQueryKey([
          gpIdKey,
          product.id,
        ])

        queryClient.setQueryData(targetQueryKey, {
          genericProduct: {
            ...data.genericProduct,
            activeProductId: product.id,
            price: {
              msrp: product.price.msrp,
              current: product.price.current,
            },
          },
        })
      })
    },
  },
}
